import React from 'react';
import { withStyles } from '@mui/styles';
import { connect } from 'react-redux';
import Avatar from 'jitsi/base/avatar/components/Avatar';
import { translate } from 'jitsi/base/i18n/functions';
import Input from 'jitsi/base/ui/components/web/Input';
import { ProfileTab, styles } from 'jitsi/settings/components/web/ProfileTab';
/**
 * React {@code Component} for modifying the local user's profile.
 *
 * @augments Component
 */
class IISightProfileTab extends ProfileTab {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { authEnabled, classes, displayName, email, hideEmailInSettings, id, readOnlyName, t } = this.props;
        return (React.createElement("div", { className: classes.container },
            React.createElement("div", { className: classes.avatarContainer },
                React.createElement(Avatar, { participantId: id, size: 60 })),
            React.createElement(Input, { className: classes.bottomMargin, disabled: readOnlyName, id: 'setDisplayName', label: t('profile.setDisplayNameLabel'), name: 'name', onChange: this._onDisplayNameChange, placeholder: t('settings.name'), type: 'text', value: displayName })));
    }
}
export default withStyles(styles)(translate(connect()(IISightProfileTab)));
